import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppSettings } from '../../proyect.conf';
import { RequisitosGarantiasProductos } from '../_models/requisito-garantia-producto';
import { AutenticacionService } from './autenticacion.service';

@Injectable({
  providedIn: 'root'
})
export class RequisitosGarantiasProductosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasProductos';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  obtenerTodos(){
    return this.httClient.get(this.rutServicio).pipe(map(res => res as RequisitosGarantiasProductos[]));
  }

  obtenerTodosEnabled(){
    return this.httClient.get(this.rutServicio).pipe(map(res => res as RequisitosGarantiasProductos[]));
  }

  obtenerTodosPorIdRequisitoProducto(id : string){
    return this.httClient.get(this.rutServicio + '/' + id).pipe(map(res => res as RequisitosGarantiasProductos[]));
  }

  obtenerPorIdRequisitoGarantia(id: string) {
    return this.httClient.get(this.rutServicio + '/requisitoGarantia/' + id).pipe(map(res => res as RequisitosGarantiasProductos[]));
  }

  listadoPorIdRequisitoGarantiaHabilitado(id: string) {
    return this.httClient.get(this.rutServicio + '/requisitoGarantia/' + id + '/enabled').pipe(map(res => res as RequisitosGarantiasProductos[]));
  }

  crear(regCrear: RequisitosGarantiasProductos) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regCrear).pipe(map(res => res as RequisitosGarantiasProductos));
  }

  actualizar(regActualizar: RequisitosGarantiasProductos) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, regActualizar).pipe(map(res => res as any));
  }
}
